import { SyntheticEvent } from 'react';

import useImageLoading from '~hooks/useImageLoading';
import { StyleType } from '~types/common';

import { S } from './style';

interface Props {
  PK_NM_HASH?: string;
  hasBorder?: boolean;
  logoCss?: StyleType;
  alt?: string;
}

/**
 *
 * @param {
 * PK_NM_HASH: company hash값
 * hasBorder?: border 유무
 * logoCss?: image wrapper size와 image size를 작성해주세요.
 * }
 * @returns
 */
function CompanyLogo({ PK_NM_HASH, hasBorder = true, logoCss, alt = 'company_logo' }: Props) {
  const logo = `https://s3.ap-northeast-2.amazonaws.com/kreditjob-public/logo/${PK_NM_HASH}`;
  const logoImg = useImageLoading(logo);

  if (!PK_NM_HASH) return null;

  return (
    <S.Logo
      hasLogo={logoImg.status === 'success'}
      hasBorder={hasBorder}
      logoCss={logoCss}
      key={PK_NM_HASH}>
      <img
        alt={alt}
        src={logo}
        width={200}
        onError={(e: SyntheticEvent<HTMLImageElement, Event>) => {
          e.currentTarget.src = 'https://static.wanted.co.kr/images/kj/default_company_logo.png';
        }}
      />
    </S.Logo>
  );
}

export default CompanyLogo;
